class IndividualProductManager {
    constructor(containerSelector) {
        this.container = document.querySelector(containerSelector);
        if (!this.container) return;
        
        this.init();
    }

    init() {
        this.container.querySelectorAll(".individual-product-button").forEach(btn => 
            btn.addEventListener("click", this.openModal.bind(this))
        );
        this.container.querySelectorAll('.js-select-product-card').forEach(label => {
            label.addEventListener('click', (event) => {
                if (event.target.tagName === 'BUTTON' || event.target.closest('button')) return;

                const radio = label.querySelector('input[type="radio"]');
                const productTitle = label.querySelector('.js-individual-product-title').innerHTML
                if (radio && !radio.checked) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                    
                    const selectedVariantId = radio.value;
                    const currentTabContent = document.querySelector('#productTabsContent .tab-pane.tabcontent.open');
                    
                    if (currentTabContent) {
                        const hiddenIdInput = currentTabContent.querySelector('input[name="id"]');
                        const hiddenSku = currentTabContent.querySelector('input[name="properties[product_sku]"]');
                        const hiddenTitle = currentTabContent.querySelector('input[name="properties[_product_title]"]');
                        const hiddenHandle = currentTabContent.querySelector('input[name="properties[_product_handle]"]');
                        const hiddenId = currentTabContent.querySelector('input[name="properties[_product_id]"]');
                        console.log(currentTabContent.querySelector('.js-individual-product-title'),'what');
                        currentTabContent.querySelector('.js-individual-title').innerHTML = productTitle;
                        if (hiddenIdInput) {
                            hiddenIdInput.value = selectedVariantId;
                            hiddenId.value = selectedVariantId;
                        }
                        if(hiddenTitle) {
                            hiddenTitle.value = label.querySelector('button').dataset.productTitle;
                        }
                        if(hiddenHandle) {
                            hiddenHandle.value = label.querySelector('button').dataset.productHandle;
                        }
                        if(hiddenSku) {
                          hiddenSku.value = label.querySelector('button').dataset.productSku;
                        }
                        if (window.subscriptionFlow) {
                            window.subscriptionFlow.currentVariantId = selectedVariantId;
                        }
                    }
                    this.updateVisualSelection(radio);
                }
            });
        });

        const modalCartBtn = document.querySelector("#PopupModal-individual-product [data-add-individual-product]");
        if (modalCartBtn) {
            modalCartBtn.addEventListener("click", this.addToCart.bind(this));
        }
    }

    updateVisualSelection(radio) {
        const groupName = radio.name;
        const allRadios = document.querySelectorAll(`input[name="${groupName}"]`);

        allRadios.forEach(r => {
            const cardDiv = r.closest('label')?.querySelector('.individual-product-info') || r.closest('label')?.querySelector('.d-flex');
            if (cardDiv) {
                if (r.checked) {
                    cardDiv.classList.add('active');
                } else {
                    cardDiv.classList.remove('active');
                }
            }
        });
    }

    openModal(event) {
        event.preventDefault();
        const currentElement = event.currentTarget;
        const modal = document.getElementById('PopupModal-individual-product');
        const modalHead = modal.querySelector('.modal-head');
        const modalContent = modal.querySelector('[data-individual-modal-content]');
        const cartButton = modal.querySelector('[data-add-individual-product]');
        
        const productHandle = currentElement.getAttribute('data-product-handle');
        const imageUrl = currentElement.getAttribute('data-image-url');
        const productId = currentElement.getAttribute('data-product-id');
        const variantId = currentElement.getAttribute('data-variant-id');
        const productSku = currentElement.getAttribute('data-product-sku');
        const productTitle = currentElement.getAttribute('data-product-title');
        
        const hiddenDescriptionElement = currentElement.closest('.individual-product-container')
                                          .querySelector('.js-individual-description');
        const descriptionHtml = hiddenDescriptionElement ? hiddenDescriptionElement.innerHTML : '';

        if (!productHandle || !modal) return;

          if (modalHead) {
            const existingImg = modalHead.querySelector('.individual-product-img');
            if (existingImg) existingImg.remove();

            if (imageUrl) {
                const imgHTML = `<img src="${imageUrl}" alt="${productTitle}" class="individual-product-img w-100 rounded-top-left rounded-top-right" style="display: block;">`;
                modalHead.insertAdjacentHTML('afterbegin', imgHTML);
            }
        }

        const html = `
            <div class="text-center">
                <h4 class="mb-3 text-black">${productTitle}</h4>
               
                <div class="rte" style="text-align: left;">
                    ${descriptionHtml}
                </div>
            </div>
        `;
        
        modalContent.innerHTML = html;
        
        if (cartButton) {
            cartButton.setAttribute('data-product-id', variantId);
            cartButton.setAttribute('data-variant-id', variantId);
            cartButton.setAttribute('data-product-handle', productHandle);
            cartButton.setAttribute('data-product-sku', productSku);
            cartButton.setAttribute('data-product-title', productTitle);
        }

        if (typeof modal.show === 'function') {
            modal.show(currentElement);
        } else {
            modal.classList.add('open'); 
        }
    }

    addToCart(event) {
        event.preventDefault();
        const currentElement = event.currentTarget;
        
        const variantId = currentElement.getAttribute('data-variant-id');
        const productId = currentElement.getAttribute('data-product-id');
        const productHandle = currentElement.getAttribute('data-product-handle');
        const productSku = currentElement.getAttribute('data-product-sku');
        const productTitle = currentElement.getAttribute('data-product-title');

        if (!variantId) {
            console.error("Variant ID missing for individual product.");
            return;
        }

        currentElement.classList.add("loading");

        const items = [{
            quantity: 1,
            id: parseInt(variantId),
            properties: {
                'product_sku': productSku,
                '_product_title': productTitle,
                '_product_handle': productHandle,
                '_product_id': productId
            }
        }];

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
        })
        .then(response => response.json())
        .then(response => {
            currentElement.classList.remove("loading");
            
            const modal = document.getElementById('PopupModal-individual-product');
            if (modal) {
                const innerModal = modal.querySelector('.modal');
                if (innerModal) innerModal.classList.remove('open');
                
                try {
                    if (window.Utility && typeof window.Utility.removeTrapFocus === 'function') {
                        window.Utility.removeTrapFocus(modal.openedBy);
                    }
                } catch(e) {}
            }

            const ajaxCart = document.querySelector('ajax-cart');
            if (ajaxCart) {
                ajaxCart.openCartDrawer();
                ajaxCart.getCartData(''); 
            } else {
                window.location.href = "/cart";
            }
        })
        .catch(e => {
            console.error("Error adding individual product to cart:", e);
            currentElement.classList.remove("loading");
        });
    }
}

new IndividualProductManager("#data-subscription-funnel");